import {
  ADDCART,
  ADDPRODUCT,
  DECREASEQUANTITY,
  DELETEPRODUCTCART,
  INCREASEQUANTITY
} from "./actionTypes";

export const addProduct = (product) => {
  return {
    type: ADDPRODUCT,
    payload: product,
  };
};
export const addCart = (productItem) => {
  return {
    type: ADDCART,
    payload: productItem,
  };
};

export const increaseCartQunatity = (productItem) => {
  return {
    type: INCREASEQUANTITY,
    payload: productItem,
  };
};
export const decreaseCartQunatity = (productItem) => {
  return {
    type: DECREASEQUANTITY,
    payload: productItem,
  };
};
export const deleteProductCard = (productItem) => {
  return {
    type: DELETEPRODUCTCART,
    payload: productItem,
  };
};
